import React, {createContext, useState} from "react";
import PMSDuePaymentServices from "../../services/pms_services/PMSDuePaymentServices";
import Notification from "../../components/common/Notification";

export const PMSDuePaymentContext = createContext("PMSDuePaymentContext");

const PMSDuePaymentContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [loadingPaid, setLoadingPaid] = useState(false);
    const [loadingConfirm, setLoadingConfirm] = useState(false);
    const [loadingCancel, setLoadingCancel] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const [duePayments, setDuePayments] = useState([]);
    const [paidPayments, setPaidPayments] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [paidTotalElements, setPaidTotalElements] = useState(0);
    const [dueTotal, setDueTotal] = useState(0);
    const [paidTotal, setPaidTotal] = useState(0);

    const getDuePayments = async (params) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await PMSDuePaymentServices.getDuePayments(params);
            setDuePayments(res.data.content);
            setTotalElements(res.data.totalElements);
            setDueTotal(res.headers.total || 0);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            const _error = error.response?.data?.message || error.message || "Something went wrong.";
            setErrorMsg(_error);
            Notification("error", "ERROR", _error);
            return false;
        }
    };

    const getPaidPayments = async (params) => {
        try {
            setLoadingPaid(true);
            setErrorMsg("");
            const res = await PMSDuePaymentServices.getPaidPayments(params);
            setPaidPayments(res.data.content);
            setPaidTotalElements(res.data.totalElements);
            setPaidTotal(res.headers.total || 0);
            setLoadingPaid(false);
            return true;
        } catch (error) {
            setLoadingPaid(false);
            const _error = error.response?.data?.message || error.message || "Something went wrong.";
            setErrorMsg(_error);
            Notification("error", "ERROR", _error);
            return false;
        }
    };

    const confirmDuePayment = async (id) => {
        try {
            setLoadingConfirm(true);
            setErrorMsg("");
            await PMSDuePaymentServices.confirmDuePayment(id);
            Notification("success", "Confirmed", "Due payment confirmed successfully.");
            setLoadingConfirm(false);
            return true;
        } catch (error) {
            setLoadingConfirm(false);
            const _error = error.response?.data?.message || error.message || "Something went wrong.";
            setErrorMsg(_error);
            Notification("error", "ERROR", _error);
            return false;
        }
    };

    const confirmDuePaymentWithDetails = async (id, data) => {
        try {
            setLoadingConfirm(true);
            setErrorMsg("");
            await PMSDuePaymentServices.confirmDuePaymentWithDetails(id, data);
            Notification("success", "Confirmed", "Due payment confirmed successfully.");
            setLoadingConfirm(false);
            return true;
        } catch (error) {
            setLoadingConfirm(false);
            const _error = error.response?.data?.message || error.message || "Something went wrong.";
            setErrorMsg(_error);
            Notification("error", "ERROR", _error);
            return false;
        }
    };

    const cancelDuePayment = async (id) => {
        try {
            setLoadingCancel(true);
            setErrorMsg("");
            await PMSDuePaymentServices.cancelDuePayment(id);
            Notification("success", "Cancelled", "Due payment cancelled successfully.");
            setLoadingCancel(false);
            return true;
        } catch (error) {
            setLoadingCancel(false);
            const _error = error.response?.data?.message || error.message || "Something went wrong.";
            setErrorMsg(_error);
            Notification("error", "ERROR", _error);
            return false;
        }
    };

    return (
        <PMSDuePaymentContext.Provider
            value={{
                loading,
                loadingPaid,
                loadingConfirm,
                loadingCancel,
                errorMsg,
                duePayments,
                paidPayments,
                totalElements,
                paidTotalElements,
                dueTotal,
                paidTotal,
                getDuePayments,
                getPaidPayments,
                confirmDuePayment,
                confirmDuePaymentWithDetails,
                cancelDuePayment,
            }}
        >
            {children}
        </PMSDuePaymentContext.Provider>
    );
};

export default PMSDuePaymentContextProvider;
